import React from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import InputControl from '../InputControl'
import { Modal } from 'react-bootstrap'

const validationSchema = yup.object().shape({
    start_date: yup.string().required('start date is a required field'),
    end_date: yup
        .string()
        .test(
            'custome-message',
            'end date should  be greater than start date',
            function (value) {
                return !value && value < this.parent.start_date ? false : true
            }
        )
})
const FilterForm = ({ handleCloseModal, setfilter,title,showModal,setShowModal }) => {
    const {
        watch,
        register,
        control,
        setValue,
        getValues,
        handleSubmit,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
        defaultValues: {
            end_date: new Date().toISOString().split('T')[0]
        }
    })
    function onSubmit(data) {
        let payload = {}
        payload.start_date = new Date(data?.start_date).getTime()
        payload.end_date = new Date(data?.end_date).getTime()

        setfilter(payload)
        handleCloseModal()
    }
    return (
        <Modal show={showModal} onHide={()=>setShowModal(false)}>
            <Modal.Title>{title}</Modal.Title>
            <Modal.Body>
        <form onSubmit={handleSubmit(onSubmit)} className='formModalwrap'>
            <InputControl
                register={register}
                label="Start Date"
                type="date"
                name="start_date"
                error={errors?.start_date?.message}
                max={new Date().toISOString().split('T')[0]}
            />

            <InputControl
                disabled={!watch('start_date')}
                register={register}
                label="End Date"
                type="date"
                name="end_date"
                error={errors?.end_date?.message}
                min={watch('start_date')}
                max={new Date().toISOString().split('T')[0]}
            />
        <div className="submit">
            <button type="submit">ok</button>
        </div>
        </form>
            </Modal.Body>
        </Modal>
    )
}

export default FilterForm
